import React, { useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const MIN_METERS = 3;

const ProductCard = ({ product }) => {
  const { addToCart, loading } = useCart();
  const [adding, setAdding] = useState(false);
  const [meters, setMeters] = useState(MIN_METERS);

  const handleAddToCart = async () => {
    if (meters < MIN_METERS) {
      toast.error(`Commande minimum : ${MIN_METERS} ml`);
      return;
    }
    setAdding(true);
    const result = await addToCart(product._id || product.id, meters);
    setAdding(false);

    if (result.success) {
      toast.success(`${meters} ml ajoutés au panier`, { description: product.name });
    } else {
      toast.error("Erreur lors de l'ajout au panier");
    }
  };

  return (
    <div
      data-testid={`product-card-${product._id}`}
      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group flex flex-col"
    >
      <div className="relative overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-44 sm:h-48 md:h-56 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 left-3">
          <img
            src="https://customer-assets.emergentagent.com/job_fbe0f837-d33d-4f84-bae0-21bace0d1680/artifacts/n9bb0eio_NEOPLIAGE%20sans%20fond.png"
            alt="NEOPLIAGE"
            className="h-8 opacity-90"
          />
        </div>
        {product.finish && (
          <div className="absolute bottom-3 left-3 bg-black/70 text-white text-xs px-2 py-1 rounded">
            {product.finish}
          </div>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="text-gray-900 font-semibold text-base mb-1 min-h-[3rem] line-clamp-2">
          {product.name}
        </h3>
        {product.color && (
          <p className="text-xs text-gray-500 mb-3 line-clamp-1">{product.color}</p>
        )}
        <div className="mt-auto">
          <div className="flex items-baseline justify-between mb-3">
            <div>
              <span className="text-2xl font-bold text-[#E42313]">
                {product.price.toFixed(2)} €
              </span>
              <span className="text-sm text-gray-500 ml-1">TTC / ml</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center border border-gray-300 rounded">
              <button
                type="button"
                onClick={() => setMeters(Math.max(MIN_METERS, meters - 1))}
                className="px-2 py-1.5 text-gray-600 hover:bg-gray-100"
                aria-label="Moins"
              >
                −
              </button>
              <input
                data-testid={`product-meters-${product._id}`}
                type="number"
                min={MIN_METERS}
                value={meters}
                onChange={(e) => setMeters(Math.max(MIN_METERS, parseInt(e.target.value) || MIN_METERS))}
                className="w-12 text-center text-sm py-1 focus:outline-none"
              />
              <button
                type="button"
                onClick={() => setMeters(meters + 1)}
                className="px-2 py-1.5 text-gray-600 hover:bg-gray-100"
                aria-label="Plus"
              >
                +
              </button>
              <span className="px-2 text-xs text-gray-500 border-l">ml</span>
            </div>
            <button
              data-testid={`add-to-cart-${product._id}`}
              onClick={handleAddToCart}
              disabled={adding || loading}
              className="flex-1 bg-[#E42313] text-white px-3 py-2 rounded hover:bg-[#C11A0F] transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
            >
              <ShoppingCart className="w-4 h-4" />
              {adding ? 'Ajout...' : 'Ajouter'}
            </button>
          </div>
          <p className="text-[11px] text-gray-400 mt-2">Minimum {MIN_METERS} ml • Max 3 m / pièce</p>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
